<template>
  <div class="questions">
    <div class="title">{{ $tr('responses.tabs.bcg-test.questions.answers') }}</div>
    <div
      class="no-data"
      v-if="!questions.length">{{ $tr('responses.tabs.test.screenshots.noData') }}
    </div>
    <template v-else>
      <bcg-response-tab-test-question-tabs
        :questions="questions"
        :selected_question="selected_question"
        @select="selected_question = $event"/>
      <bcg-response-tab-test-question :selected_question="selected_question"/>
    </template>
  </div>
</template>
<script>
  import BcgResponseTabTestQuestionTabs from './question-tabs';
  import BcgResponseTabTestQuestion from './question';

  export default {
    name: 'bcg-response-tab-test-questions-wrapper',
    components: {
      BcgResponseTabTestQuestion,
      BcgResponseTabTestQuestionTabs,
    },
    data () {
      return {
        selected_question: 0,
      }
    },
    props: {
      questions: {
        type: Array,
        required: true,
      }
    },
    created () {
      this.selected_question = this.questions[0];
    },
  }
</script>
<style scoped lang="scss">
  .questions {
    margin: 10px 0;
    padding: 5px 0;

    .title {
      margin: 10px 0;
      font-size: 16px;
      font-weight: bold;
    }
    .no-data {
      margin: 10px 0;
      font-size: 15px;
    }

    border-bottom: 1px solid #d7d7d7;
  }
</style>
